(function () {
  function $(selector) {
    return document.querySelector(selector);
  }

  function $all(selector) {
    return Array.from(document.querySelectorAll(selector));
  }

  function debugLog() {
    let enabled = false;
    try {
      enabled =
        Boolean(window.DEBUG || window.__IMAGE_UPSCALER_DEBUG__) ||
        localStorage.getItem('netwrck_image_upscaler_debug') === '1';
    } catch (_) {}
    if (!enabled) return;
    console.log.apply(console, arguments);
  }

  function showProgress(show) {
    var el = $('#create-ai-loading-progress');
    if (!el) return;
    el.style.display = show ? 'block' : 'none';
  }

  function getUploadedImageUrl() {
    if (window.uploadedImageUrl) return window.uploadedImageUrl;
    var img = document.querySelector('#new-ai-avatar-image img');
    return img ? img.src : '';
  }

  function renderResultImage(url, altText) {
    var list = $('#createdImagePicsList');
    if (!list) return;
    var container = document.createElement('div');
    container.className =
      'ai-char-item mdl-cell mdl-cell--stretch mdl-cell--6-col mdl-list__item mdl-list__item--three-line';

    var editorLink = document.createElement('a');
    editorLink.className =
      'mdl-editor-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored';
    editorLink.target = '_blank';
    editorLink.href =
      'https://editor.ebank.nz/index.html?imageUrl=' + encodeURIComponent(url);
    editorLink.innerHTML = '<i class="material-icons">brush</i>';

    var downloadLink = document.createElement('a');
    downloadLink.className =
      'mdl-editor-btn mdl-download-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored';
    downloadLink.href = url;
    downloadLink.setAttribute('download', 'upscaled.webp');
    downloadLink.innerHTML = '<i class="material-icons">download</i>';

    var img = document.createElement('img');
    img.loading = 'lazy';
    img.className = 'b8 ai-generated-char-chooser ai-generated-char-item';
    img.src = url;
    img.alt = altText || 'Upscaled image';

    container.appendChild(editorLink);
    container.appendChild(downloadLink);
    container.appendChild(img);
    list.appendChild(container);
  }

  async function runUpscale() {
    try {
      var promptInput = $('#createaiimagepromptupscaler');
      var prompt = promptInput ? promptInput.value || '' : '';
      var imageUrl = getUploadedImageUrl();
      if (!imageUrl) {
        alert('Please upload an image first.');
        return;
      }
      showProgress(true);
      var list = $('#createdImagePicsList');
      if (list) list.innerHTML = '';

      var payload = {
        model_name: 'fal-ai/creative-upscaler',
        image_url: imageUrl,
        scale: 2,
        creativity: 0.5,
        detail: 1,
        shape_preservation: 0.25,
        guidance_scale: 7.5,
        num_inference_steps: 20,
        enable_safety_checks: true,
        negative_prompt:
          'blurry, low resolution, bad, ugly, low quality, pixelated, interpolated, compression artifacts, noisey, grainy',
        prompt_suffix: ' high quality, highly detailed, high resolution, sharp',
      };
      if (prompt) {
        payload.prompt = prompt;
      }

      var res = await fetch('/fal', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        let errData = null;
        try {
          errData = await res.json();
        } catch {}
        if (res.status === 401 && errData && errData.redirect) {
          window.location.href =
            errData.redirect +
            '?next=' +
            encodeURIComponent(
              window.location.pathname + window.location.search
            );
          return;
        }
        if (res.status === 402 && errData && errData.message) {
          alert(errData.message);
          return;
        }
        throw new Error(
          (errData && (errData.error || errData.message)) ||
            'Upscale request failed'
        );
      }
      var data = await res.json();
      var outputUrl =
        data && data.result && data.result.image && data.result.image.url;
      if (!outputUrl) {
        outputUrl = data && data.image && data.image.url;
      }
      if (!outputUrl) {
        outputUrl = data && (data.output || data.url || data.image_url);
      }
      if (!outputUrl) throw new Error('No output received from upscaler');

      renderResultImage(outputUrl, prompt);
      if (typeof window.trackEvent === 'function') {
        try {
          window.trackEvent('ai', 'upscale', 'success');
        } catch {}
      }
    } catch (err) {
      console.error('Upscale error:', err);
      alert('Upscale failed: ' + (err && err.message ? err.message : err));
      if (typeof window.trackEvent === 'function') {
        try {
          window.trackEvent('ai', 'upscale', 'fail');
        } catch {}
      }
    } finally {
      showProgress(false);
    }
  }

  function bindEvents() {
    $all('.create-ai-image-button-upscaler').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        runUpscale();
      });
    });
    var input = $('#createaiimagepromptupscaler');
    if (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          runUpscale();
        }
      });
    }
  }

  document.addEventListener('imageFilePasted', async function (event) {
    try {
      const blob = event && event.detail && event.detail.file;
      if (!blob || !blob.type || !blob.type.startsWith('image/')) return;
      await handlePastedImage(blob);
    } catch (err) {
      console.warn('[image-upscaler] Failed to handle pasted image:', err);
    }
  });

  if (typeof jQuery !== 'undefined') {
    jQuery(document).on('tool-image-pasted', async function (_e, blob) {
      try {
        if (!blob || !blob.type || !blob.type.startsWith('image/')) return;
        await handlePastedImage(blob);
      } catch (err) {
        console.warn('[image-upscaler] jQuery paste handler failed:', err);
      }
    });
  }

  async function handlePastedImage(file) {
    try {
      const name = `upscale-${Date.now()}.webp`;
      let uploadBlob = file;
      if (window.MediaProcessor) {
        try {
          const processor = new window.MediaProcessor();
          uploadBlob = await processor.convertToWebP(file, 0.85, 2048, 2048);
        } catch {}
      }
      const signed = await (
        window.getSignedURLAndUpload || getSignedURLAndUpload
      )(uploadBlob, uploadBlob.type || 'image/webp', name);
      const bucket = signed.bucket_name || 'netwrckstatic.netwrck.com';
      const url = `https://${bucket}/${signed.object_path}`;
      const avatar = document.getElementById('new-ai-avatar-image');
      if (avatar) {
        avatar.innerHTML = `<img src="${url}" width="81" height="81" alt="Upscaler source"/>`;
      }
      window.uploadedImageUrl = url;
      debugLog('[image-upscaler] Pasted image uploaded:', url);
    } catch (err) {
      console.error('[image-upscaler] Upload failed:', err);
      alert('Failed to upload pasted image. Please try again.');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindEvents);
  } else {
    bindEvents();
  }

  debugLog('[tools] image-upscaler initialized');
})();
